import { connect } from 'react-redux';

import { FatFeatureList, IFatFeatureStoreProps } from '../../components/FatFeatureList';
import { IState } from '../../store';
import { IFatNewobjectCategorySetData } from '../../types';

export type TStoreProps = IFatFeatureStoreProps;

export function mapStateToProps(state: IState): TStoreProps {
  const { fatFeatureList } = state.villageData.village || ({} as IFatNewobjectCategorySetData);

  return {
    featureList: fatFeatureList || [],
    isHidden: !state.isFatCard,
  };
}

export const FatFeatureListContainer = connect<TStoreProps>(mapStateToProps)(FatFeatureList);
